<section class="tk-stela-page-head">
  <div class="tk-stela-page-head-top">
    <div class="tk-stela-page-head-main min-w-0">
      <h1 class="tk-stela-page-head-title">{{ title() }}</h1>
      <!-- Stela 2 prototype (.page-header): breadcrumbs sit under the title. -->
      @if (breadcrumbs()?.length) {
        <stela-breadcrumbs [items]="breadcrumbs()" />
      }
      @if (metadata()) {
        <p class="tk-stela-page-head-metadata">{{ metadata() }}</p>
      }
    </div>

    <div class="tk-stela-page-head-actions">
      <ng-container [ngTemplateOutlet]="actionsTemplate()"></ng-container>
    </div>
  </div>

  @if (kpisTemplate()) {
    <div class="tk-stela-page-head-kpis">
      <ng-container [ngTemplateOutlet]="kpisTemplate()!"></ng-container>
    </div>
  }

  @if (chipsTemplate()) {
    <div class="tk-stela-page-head-chips">
      <ng-container [ngTemplateOutlet]="chipsTemplate()!"></ng-container>
    </div>
  }
</section>
